import adapters from './adapters';

export default adapters;
